var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _ellipse5, _ellipse6, _ellipse7, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _g, _path201, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 230,
    viewBox: "0 0 189 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10322_10919)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10322_10919)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "#601F93"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2227 200.982C21.3922 203.408 21.7315 234.806 18 252.625V269.542L233.746 278L237.477 155.861C244.601 118.644 176.982 98.4061 151.315 122.365C124.855 147.064 129.265 197.937 69.2227 200.982Z",
    fill: "#6A48B3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.706 210.385H117.611V221.948H127.706V210.385Z",
    fill: "#463332"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.706 212.814H117.611V216.436H127.706V212.814Z",
    fill: "#463332"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.859 156.096H87.4579C85.3523 156.096 83.6454 157.792 83.6454 159.885V208.928C83.6454 211.02 85.3523 212.717 87.4579 212.717H157.859C159.965 212.717 161.672 211.02 161.672 208.928V159.885C161.672 157.792 159.965 156.096 157.859 156.096Z",
    fill: "url(#paint0_linear_10322_10919)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6454 205.871V209.078C83.6454 211.268 85.3517 213.053 87.4578 213.053H157.859C159.965 213.053 161.672 211.277 161.672 209.078V205.871H83.6454Z",
    fill: "url(#paint1_linear_10322_10919)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.428 157.253H88.8975C86.8803 157.253 85.245 158.878 85.245 160.883V200.121C85.245 202.126 86.8803 203.751 88.8975 203.751H156.428C158.446 203.751 160.081 202.126 160.081 200.121V160.883C160.081 158.878 158.446 157.253 156.428 157.253Z",
    fill: "url(#paint2_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.015 159.346C156.375 158.675 155.469 158.251 154.464 158.251H89.7417C87.8044 158.251 86.2403 159.806 86.2403 161.731V199.343C86.2403 200.138 86.5069 200.88 86.969 201.463L157.015 159.346Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.626 220.287H134.691C135.687 220.287 136.495 221.091 136.495 222.08V224.607H108.813V222.08C108.813 221.091 109.622 220.287 110.617 220.287H110.626Z",
    fill: "url(#paint3_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.691 220.287H122.756C123.752 220.287 124.56 221.091 124.56 222.08V224.607H136.495V222.08C136.495 221.091 135.687 220.287 134.691 220.287Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.673 221.471C117.673 222.063 114.403 222.187 112.065 222.187C109.995 222.187 109.666 221.869 109.666 221.471C109.666 221.074 110.137 220.756 112.065 220.756C114.403 220.756 117.673 220.888 117.673 221.471Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.179 221.471C120.179 221.709 119.717 221.877 119.211 221.877C118.704 221.877 118.349 221.692 118.349 221.471C118.349 221.25 118.704 221.064 119.211 221.064C119.717 221.064 120.179 221.232 120.179 221.471Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.504 223.812H108.822V224.607H136.504V223.812Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.672 205.871H83.6454V206.905H161.672V205.871Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.157 209.626C157.157 210.438 156.491 211.101 155.673 211.101C154.855 211.101 154.189 210.438 154.189 209.626C154.189 208.813 154.855 208.15 155.673 208.15C156.491 208.15 157.157 208.813 157.157 209.626Z",
    fill: "#463332"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.66 209.626C156.66 210.165 156.224 210.598 155.682 210.598C155.14 210.598 154.704 210.165 154.704 209.626C154.704 209.087 155.14 208.654 155.682 208.654C156.224 208.654 156.66 209.087 156.66 209.626Z",
    fill: "url(#paint4_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.761 160.771H125.844V201.889H156.761V160.771Z",
    fill: "#6D4791"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.761 159.189H125.844V200.308H156.761V159.189Z",
    fill: "#FFF4EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154.69 161.009H127.896V164.975H154.69V161.009Z",
    fill: "url(#paint5_linear_10322_10919)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.351 164.267V161.9H133.636V164.041H134.743V164.267H133.351Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M135.135 164.267V161.9H136.606V162.133H135.421V162.958H136.504V163.188H135.421V164.034H136.606V164.267H135.135Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M137.81 164.308C137.635 164.308 137.484 164.276 137.355 164.213C137.225 164.15 137.126 164.062 137.056 163.949C136.985 163.836 136.95 163.706 136.95 163.557H137.249C137.249 163.649 137.271 163.735 137.314 163.814C137.357 163.891 137.419 163.953 137.501 164C137.584 164.045 137.687 164.068 137.81 164.068C137.97 164.068 138.095 164.029 138.183 163.953C138.271 163.876 138.316 163.78 138.316 163.665C138.316 163.57 138.295 163.495 138.255 163.439C138.214 163.38 138.158 163.333 138.088 163.297C138.02 163.26 137.941 163.229 137.85 163.202C137.762 163.175 137.669 163.144 137.572 163.111C137.388 163.047 137.253 162.97 137.164 162.877C137.076 162.783 137.032 162.66 137.032 162.509C137.03 162.382 137.059 162.271 137.12 162.174C137.181 162.075 137.267 161.998 137.378 161.944C137.492 161.888 137.625 161.859 137.779 161.859C137.931 161.859 138.062 161.888 138.173 161.944C138.286 162 138.373 162.078 138.434 162.177C138.498 162.276 138.531 162.389 138.533 162.515H138.234C138.234 162.45 138.217 162.386 138.183 162.323C138.149 162.257 138.097 162.204 138.027 162.164C137.959 162.123 137.873 162.103 137.769 162.103C137.64 162.101 137.533 162.133 137.45 162.201C137.368 162.269 137.327 162.362 137.327 162.482C137.327 162.583 137.356 162.661 137.412 162.715C137.471 162.769 137.553 162.814 137.657 162.85C137.761 162.884 137.881 162.923 138.017 162.969C138.13 163.009 138.232 163.056 138.322 163.111C138.413 163.165 138.483 163.235 138.533 163.32C138.585 163.406 138.611 163.515 138.611 163.648C138.611 163.761 138.582 163.868 138.523 163.969C138.464 164.069 138.374 164.15 138.255 164.213C138.137 164.276 137.988 164.308 137.81 164.308Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M139.773 164.308C139.599 164.308 139.447 164.276 139.318 164.213C139.189 164.15 139.089 164.062 139.019 163.949C138.949 163.836 138.914 163.706 138.914 163.557H139.213C139.213 163.649 139.234 163.735 139.277 163.814C139.32 163.891 139.382 163.953 139.464 164C139.548 164.045 139.651 164.068 139.773 164.068C139.934 164.068 140.058 164.029 140.147 163.953C140.235 163.876 140.279 163.78 140.279 163.665C140.279 163.57 140.259 163.495 140.218 163.439C140.177 163.38 140.122 163.333 140.051 163.297C139.984 163.26 139.904 163.229 139.814 163.202C139.725 163.175 139.633 163.144 139.535 163.111C139.352 163.047 139.216 162.97 139.128 162.877C139.039 162.783 138.995 162.66 138.995 162.509C138.993 162.382 139.022 162.271 139.084 162.174C139.145 162.075 139.231 161.998 139.342 161.944C139.455 161.888 139.588 161.859 139.742 161.859C139.894 161.859 140.025 161.888 140.136 161.944C140.25 162 140.337 162.078 140.398 162.177C140.461 162.276 140.494 162.389 140.496 162.515H140.198C140.198 162.45 140.181 162.386 140.147 162.323C140.113 162.257 140.061 162.204 139.99 162.164C139.922 162.123 139.836 162.103 139.732 162.103C139.603 162.101 139.497 162.133 139.413 162.201C139.331 162.269 139.291 162.362 139.291 162.482C139.291 162.583 139.319 162.661 139.376 162.715C139.435 162.769 139.516 162.814 139.62 162.85C139.724 162.884 139.844 162.923 139.98 162.969C140.093 163.009 140.195 163.056 140.286 163.111C140.376 163.165 140.447 163.235 140.496 163.32C140.548 163.406 140.574 163.515 140.574 163.648C140.574 163.761 140.545 163.868 140.486 163.969C140.427 164.069 140.338 164.15 140.218 164.213C140.1 164.276 139.952 164.308 139.773 164.308Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.059 164.308C141.826 164.308 141.621 164.257 141.444 164.155C141.27 164.052 141.133 163.907 141.033 163.723C140.936 163.538 140.887 163.325 140.887 163.084C140.887 162.842 140.936 162.63 141.033 162.448C141.133 162.263 141.27 162.119 141.444 162.015C141.621 161.911 141.826 161.859 142.059 161.859C142.294 161.859 142.499 161.911 142.674 162.015C142.85 162.119 142.987 162.263 143.085 162.448C143.182 162.63 143.231 162.842 143.231 163.084C143.231 163.325 143.182 163.538 143.085 163.723C142.987 163.907 142.85 164.052 142.674 164.155C142.499 164.257 142.294 164.308 142.059 164.308ZM142.059 164.057C142.233 164.057 142.386 164.019 142.517 163.942C142.651 163.864 142.754 163.752 142.827 163.608C142.901 163.461 142.939 163.286 142.939 163.084C142.939 162.881 142.901 162.707 142.827 162.563C142.754 162.418 142.651 162.308 142.517 162.231C142.386 162.152 142.233 162.113 142.059 162.113C141.885 162.113 141.731 162.152 141.597 162.231C141.466 162.308 141.363 162.418 141.288 162.563C141.216 162.707 141.179 162.881 141.179 163.084C141.179 163.286 141.216 163.461 141.288 163.608C141.363 163.752 141.466 163.864 141.597 163.942C141.731 164.019 141.885 164.057 142.059 164.057Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M143.642 164.267V161.9H143.927L145.194 163.797V161.9H145.479V164.267H145.194L143.927 162.37V164.267H143.642Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147.117 164.267V162.218L146.733 162.302V162.106L147.212 161.9H147.405V164.267H147.117Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.87 164.267V164.068C148.031 163.941 148.182 163.814 148.325 163.685C148.47 163.555 148.598 163.426 148.709 163.3C148.822 163.174 148.91 163.05 148.974 162.928C149.039 162.806 149.072 162.689 149.072 162.576C149.072 162.493 149.057 162.415 149.028 162.343C149.001 162.271 148.955 162.213 148.892 162.17C148.829 162.125 148.743 162.103 148.634 162.103C148.53 162.103 148.443 162.127 148.372 162.174C148.302 162.219 148.249 162.28 148.213 162.356C148.179 162.433 148.162 162.515 148.162 162.603H147.887C147.887 162.448 147.92 162.315 147.985 162.204C148.051 162.092 148.14 162.006 148.254 161.947C148.367 161.889 148.495 161.859 148.637 161.859C148.848 161.859 149.02 161.919 149.154 162.039C149.289 162.156 149.357 162.332 149.357 162.566C149.357 162.706 149.322 162.845 149.252 162.982C149.182 163.117 149.092 163.249 148.984 163.378C148.875 163.504 148.759 163.622 148.634 163.733C148.512 163.843 148.397 163.942 148.291 164.03H149.439V164.267H147.87Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 167.802L139.644 167.199H133.351L133.358 167.802H139.651Z",
    fill: "#DDC8BA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 167.802L154.252 167.199H140.383L140.397 167.802H154.266Z",
    fill: "#DDC8BA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 170.638L139.644 170.035H133.351L133.358 170.638H139.651Z",
    fill: "#DDC8BA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 170.638L154.252 170.035H140.383L140.397 170.638H154.266Z",
    fill: "#DDC8BA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 169.218V168.614H147.045L147.059 169.218H154.266Z",
    fill: "#DDC8BA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 169.218V168.614H133.351L133.365 169.218H146.424Z",
    fill: "#DDC8BA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M136.951 172.066L136.944 171.463H133.351L133.358 172.066H136.951Z",
    fill: "#DDC8BA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M146.104 172.039L146.09 171.436H137.69L137.697 172.039H146.104Z",
    fill: "#DDC8BA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 174.744L139.644 174.141H133.351L133.358 174.744H139.651Z",
    fill: "#DDC8BA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 174.744L154.252 174.141H140.383L140.397 174.744H154.266Z",
    fill: "#DDC8BA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 177.58L139.644 176.977H133.351L133.358 177.58H139.651Z",
    fill: "#DDC8BA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 177.58L154.252 176.977H140.383L140.397 177.58H154.266Z",
    fill: "#DDC8BA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 176.159V175.556H147.045L147.059 176.159H154.266Z",
    fill: "#DDC8BA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 176.159V175.556H133.351L133.365 176.159H146.424Z",
    fill: "#DDC8BA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.951 179.009L136.944 178.405H133.351L133.358 179.009H136.951Z",
    fill: "#DDC8BA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M146.104 178.981L146.09 178.378H137.69L137.697 178.981H146.104Z",
    fill: "#DDC8BA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 181.685L139.644 181.082H133.351L133.358 181.685H139.651Z",
    fill: "#DDC8BA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 181.685L154.252 181.082H140.383L140.397 181.685H154.266Z",
    fill: "#DDC8BA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 184.521L139.644 183.918H133.351L133.358 184.521H139.651Z",
    fill: "#DDC8BA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 184.521L154.252 183.918H140.383L140.397 184.521H154.266Z",
    fill: "#DDC8BA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 183.099V182.496H147.045L147.059 183.099H154.266Z",
    fill: "#DDC8BA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 183.099V182.496H133.351L133.365 183.099H146.424Z",
    fill: "#DDC8BA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M136.951 185.95L136.944 185.347H133.351L133.358 185.95H136.951Z",
    fill: "#DDC8BA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M146.104 185.922L146.09 185.318H137.69L137.697 185.922H146.104Z",
    fill: "#DDC8BA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 188.627L139.644 188.023H133.351L133.358 188.627H139.651Z",
    fill: "#DDC8BA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 188.627L154.252 188.023H140.383L140.397 188.627H154.266Z",
    fill: "#DDC8BA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 191.463L139.644 190.859H133.351L133.358 191.463H139.651Z",
    fill: "#DDC8BA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 191.463L154.252 190.859H140.383L140.397 191.463H154.266Z",
    fill: "#DDC8BA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 190.041V189.438H147.045L147.059 190.041H154.266Z",
    fill: "#DDC8BA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 190.041V189.438H133.351L133.365 190.041H146.424Z",
    fill: "#DDC8BA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M136.951 192.89L136.944 192.287H133.351L133.358 192.89H136.951Z",
    fill: "#DDC8BA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M146.104 192.863L146.09 192.26H137.69L137.697 192.863H146.104Z",
    fill: "#DDC8BA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 194.501L139.644 193.897H133.351L133.358 194.501H139.651Z",
    fill: "#DDC8BA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 194.501L154.252 193.897H140.383L140.397 194.501H154.266Z",
    fill: "#DDC8BA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 197.337L139.644 196.733H133.351L133.358 197.337H139.651Z",
    fill: "#DDC8BA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 197.337L154.252 196.733H140.383L140.397 197.337H154.266Z",
    fill: "#DDC8BA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 195.916V195.312H147.045L147.059 195.916H154.266Z",
    fill: "#DDC8BA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 195.916V195.312H133.351L133.365 195.916H146.424Z",
    fill: "#DDC8BA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.134,
    cy: 168.801,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint6_linear_10322_10919)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.134,
    cy: 175.743,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint7_linear_10322_10919)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.134,
    cy: 182.684,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint8_linear_10322_10919)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.134,
    cy: 189.625,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint9_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M121.904 160.98H90.9865V202.099H121.904V160.98Z",
    fill: "#6D4791"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M121.904 159.399H90.9866V200.518H121.904V159.399Z",
    fill: "#FFF4EE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 167.802L104.786 167.198H98.494L98.501 167.802H104.793Z",
    fill: "#DDC8BA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 167.802L119.394 167.198H105.526L105.54 167.802H119.408Z",
    fill: "#DDC8BA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 170.637L104.786 170.034H98.494L98.501 170.637H104.793Z",
    fill: "#DDC8BA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 170.637L119.394 170.034H105.526L105.54 170.637H119.408Z",
    fill: "#DDC8BA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 169.217V168.613H112.188L112.202 169.217H119.408Z",
    fill: "#DDC8BA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M111.567 169.217V168.613H98.494L98.508 169.217H111.567Z",
    fill: "#DDC8BA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M102.094 172.066L102.087 171.463H98.494L98.501 172.066H102.094Z",
    fill: "#DDC8BA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M111.246 172.038L111.232 171.435H102.833L102.84 172.038H111.246Z",
    fill: "#DDC8BA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 174.744L104.786 174.141H98.494L98.501 174.744H104.793Z",
    fill: "#DDC8BA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 174.744L119.394 174.141H105.526L105.54 174.744H119.408Z",
    fill: "#DDC8BA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 177.58L104.786 176.977H98.494L98.501 177.58H104.793Z",
    fill: "#DDC8BA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 177.58L119.394 176.977H105.526L105.54 177.58H119.408Z",
    fill: "#DDC8BA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 176.159V175.556H112.188L112.202 176.159H119.408Z",
    fill: "#DDC8BA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M111.567 176.159V175.556H98.494L98.508 176.159H111.567Z",
    fill: "#DDC8BA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M102.094 179.008L102.087 178.404H98.494L98.501 179.008H102.094Z",
    fill: "#DDC8BA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M111.246 178.98L111.232 178.377H102.833L102.84 178.98H111.246Z",
    fill: "#DDC8BA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 181.685L104.786 181.082H98.494L98.501 181.685H104.793Z",
    fill: "#DDC8BA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 181.685L119.394 181.082H105.526L105.54 181.685H119.408Z",
    fill: "#DDC8BA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 184.521L104.786 183.918H98.494L98.501 184.521H104.793Z",
    fill: "#DDC8BA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 184.521L119.394 183.918H105.526L105.54 184.521H119.408Z",
    fill: "#DDC8BA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 183.1V182.497H112.188L112.202 183.1H119.408Z",
    fill: "#DDC8BA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M111.567 183.1V182.497H98.494L98.508 183.1H111.567Z",
    fill: "#DDC8BA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M102.094 185.95L102.087 185.347H98.494L98.501 185.95H102.094Z",
    fill: "#DDC8BA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M111.246 185.922L111.232 185.318H102.833L102.84 185.922H111.246Z",
    fill: "#DDC8BA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M101.156 189.909L101.147 189.141H93.1314L93.1403 189.909H101.156Z",
    fill: "#DDC8BA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 189.909L119.756 189.141H102.089L102.107 189.909H119.774Z",
    fill: "#DDC8BA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 188.258V187.489H110.576L110.594 188.258H119.774Z",
    fill: "#DDC8BA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M109.785 188.258V187.489H93.1314L93.1492 188.258H109.785Z",
    fill: "#DDC8BA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M97.717 191.579L97.7081 190.811H93.1314L93.1403 191.579H97.717Z",
    fill: "#DDC8BA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M109.376 191.544L109.359 190.775H98.659L98.6679 191.544H109.376Z",
    fill: "#DDC8BA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M119.833 161.219H93.0393V165.185H119.833V161.219Z",
    fill: "url(#paint10_linear_10322_10919)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M98.494 164.484V161.903H98.7984V164.237H99.9796V164.484H98.494Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M100.398 164.484V161.903H101.967V162.157H100.702V163.057H101.858V163.308H100.702V164.23H101.967V164.484H100.398Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M103.251 164.528C103.065 164.528 102.903 164.494 102.765 164.425C102.628 164.356 102.521 164.26 102.446 164.137C102.372 164.014 102.334 163.872 102.334 163.71H102.653C102.653 163.81 102.676 163.904 102.722 163.99C102.768 164.073 102.834 164.141 102.921 164.193C103.01 164.242 103.12 164.266 103.251 164.266C103.422 164.266 103.555 164.225 103.649 164.141C103.744 164.057 103.791 163.953 103.791 163.828C103.791 163.724 103.769 163.642 103.725 163.581C103.682 163.517 103.623 163.465 103.548 163.426C103.475 163.386 103.391 163.352 103.294 163.322C103.2 163.293 103.101 163.26 102.997 163.223C102.802 163.154 102.657 163.069 102.562 162.968C102.468 162.865 102.421 162.731 102.421 162.566C102.419 162.429 102.45 162.307 102.515 162.201C102.581 162.093 102.672 162.01 102.791 161.951C102.911 161.889 103.054 161.858 103.218 161.858C103.38 161.858 103.52 161.889 103.639 161.951C103.759 162.012 103.852 162.097 103.918 162.205C103.985 162.313 104.02 162.436 104.023 162.574H103.704C103.704 162.503 103.686 162.432 103.649 162.364C103.613 162.292 103.558 162.235 103.483 162.19C103.41 162.146 103.318 162.124 103.207 162.124C103.07 162.121 102.956 162.157 102.867 162.231C102.78 162.305 102.736 162.407 102.736 162.537C102.736 162.648 102.767 162.732 102.827 162.791C102.89 162.85 102.977 162.9 103.088 162.939C103.199 162.976 103.327 163.019 103.472 163.068C103.593 163.112 103.701 163.164 103.798 163.223C103.895 163.282 103.969 163.358 104.023 163.451C104.078 163.545 104.106 163.664 104.106 163.809C104.106 163.932 104.075 164.049 104.012 164.159C103.949 164.268 103.853 164.356 103.725 164.425C103.6 164.494 103.442 164.528 103.251 164.528Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M105.346 164.528C105.16 164.528 104.998 164.494 104.86 164.425C104.722 164.356 104.616 164.26 104.541 164.137C104.466 164.014 104.429 163.872 104.429 163.71H104.748C104.748 163.81 104.771 163.904 104.817 163.99C104.862 164.073 104.929 164.141 105.016 164.193C105.105 164.242 105.215 164.266 105.346 164.266C105.517 164.266 105.65 164.225 105.744 164.141C105.838 164.057 105.885 163.953 105.885 163.828C105.885 163.724 105.864 163.642 105.82 163.581C105.777 163.517 105.718 163.465 105.643 163.426C105.57 163.386 105.486 163.352 105.389 163.322C105.295 163.293 105.196 163.26 105.092 163.223C104.896 163.154 104.751 163.069 104.657 162.968C104.563 162.865 104.516 162.731 104.516 162.566C104.513 162.429 104.545 162.307 104.61 162.201C104.675 162.093 104.767 162.01 104.885 161.951C105.006 161.889 105.149 161.858 105.313 161.858C105.475 161.858 105.615 161.889 105.733 161.951C105.854 162.012 105.947 162.097 106.012 162.205C106.08 162.313 106.115 162.436 106.117 162.574H105.798C105.798 162.503 105.78 162.432 105.744 162.364C105.708 162.292 105.652 162.235 105.577 162.19C105.505 162.146 105.413 162.124 105.302 162.124C105.164 162.121 105.051 162.157 104.961 162.231C104.874 162.305 104.831 162.407 104.831 162.537C104.831 162.648 104.861 162.732 104.922 162.791C104.984 162.85 105.071 162.9 105.182 162.939C105.294 162.976 105.422 163.019 105.567 163.068C105.687 163.112 105.796 163.164 105.893 163.223C105.989 163.282 106.064 163.358 106.117 163.451C106.173 163.545 106.201 163.664 106.201 163.809C106.201 163.932 106.169 164.049 106.106 164.159C106.044 164.268 105.948 164.356 105.82 164.425C105.695 164.494 105.536 164.528 105.346 164.528Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M107.784 164.528C107.536 164.528 107.317 164.473 107.129 164.362C106.943 164.249 106.796 164.092 106.69 163.89C106.586 163.689 106.534 163.456 106.534 163.193C106.534 162.93 106.586 162.699 106.69 162.5C106.796 162.298 106.943 162.141 107.129 162.028C107.317 161.915 107.536 161.858 107.784 161.858C108.036 161.858 108.254 161.915 108.44 162.028C108.629 162.141 108.775 162.298 108.879 162.5C108.983 162.699 109.034 162.93 109.034 163.193C109.034 163.456 108.983 163.689 108.879 163.89C108.775 164.092 108.629 164.249 108.44 164.362C108.254 164.473 108.036 164.528 107.784 164.528ZM107.784 164.255C107.97 164.255 108.133 164.214 108.274 164.13C108.416 164.044 108.526 163.922 108.603 163.765C108.683 163.605 108.723 163.415 108.723 163.193C108.723 162.972 108.683 162.783 108.603 162.625C108.526 162.468 108.416 162.348 108.274 162.264C108.133 162.178 107.97 162.135 107.784 162.135C107.598 162.135 107.434 162.178 107.292 162.264C107.152 162.348 107.042 162.468 106.962 162.625C106.885 162.783 106.846 162.972 106.846 163.193C106.846 163.415 106.885 163.605 106.962 163.765C107.042 163.922 107.152 164.044 107.292 164.13C107.434 164.214 107.598 164.255 107.784 164.255Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M109.474 164.484V161.903H109.778L111.129 163.971V161.903H111.434V164.484H111.129L109.778 162.415V164.484H109.474Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M113.181 164.484V162.249L112.771 162.341V162.128L113.282 161.903H113.488V164.484H113.181Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M114.274 164.484V162.249L113.864 162.341V162.128L114.375 161.903H114.582V164.484H114.274Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M101.156 194.132L101.147 193.363H93.1314L93.1403 194.132H101.156Z",
    fill: "#DDC8BA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 194.132L119.756 193.363H102.089L102.107 194.132H119.774Z",
    fill: "#DDC8BA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M101.156 197.745L101.147 196.977H93.1314L93.1403 197.745H101.156Z",
    fill: "#DDC8BA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 197.745L119.756 196.977H102.089L102.107 197.745H119.774Z",
    fill: "#DDC8BA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 195.934V195.165H110.576L110.594 195.934H119.774Z",
    fill: "#DDC8BA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M109.785 195.934V195.165H93.1314L93.1492 195.934H109.785Z",
    fill: "#DDC8BA"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.2766,
    cy: 168.801,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint11_linear_10322_10919)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.2766,
    cy: 175.743,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint12_linear_10322_10919)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.2766,
    cy: 182.684,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint13_linear_10322_10919)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M137.926 224.148C139.064 224.148 140.112 222.938 140.272 221.445C140.432 219.952 139.579 218.751 138.024 218.751C136.887 218.751 136.336 219.961 136.167 221.454C136.007 222.947 136.789 224.148 137.926 224.148ZM137.055 221.542C137.144 220.721 137.446 220.049 138.077 220.049C138.93 220.049 139.401 220.712 139.313 221.533C139.224 222.355 138.646 223.026 138.024 223.026C137.402 223.026 136.966 222.364 137.055 221.542Z",
    fill: "url(#paint14_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M137.926 224.148C139.064 224.148 140.112 222.938 140.272 221.445C140.432 219.952 139.579 218.751 138.024 218.751C136.887 218.751 136.336 219.961 136.167 221.454C136.007 222.947 136.789 224.148 137.926 224.148ZM137.055 221.542C137.144 220.721 137.446 220.049 138.077 220.049C138.93 220.049 139.401 220.712 139.313 221.533C139.224 222.355 138.646 223.026 138.024 223.026C137.402 223.026 136.966 222.364 137.055 221.542Z",
    fill: "#398191"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M129.032 227.343L137.031 227.32C137.276 227.319 137.474 227.121 137.474 226.877L137.441 216.038C137.44 215.794 137.241 215.597 136.996 215.598L128.997 215.622C128.752 215.622 128.554 215.821 128.554 216.065L128.587 226.903C128.588 227.147 128.787 227.344 129.032 227.343Z",
    fill: "url(#paint15_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M134.737 215.614L137.039 215.621C137.279 215.622 137.474 215.817 137.473 216.055L137.441 226.911C137.44 227.15 137.244 227.343 137.004 227.343L134.702 227.336L134.737 215.614Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M129.306 216.189C129.306 216.189 130.879 218.036 130.87 221.648C130.861 225.27 129.315 226.445 129.315 226.445V216.181L129.306 216.189Z",
    fill: "#FFF7E6"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M133.438 215.049C133.847 212.267 128.373 213.601 128.373 211.286C128.373 208.972 136.3 208.972 136.3 207.576C136.3 206.181 131.634 206.825 131.634 205.085C131.634 203.345 137.109 202.656 135.42 200.916C135.42 200.916 136.815 201.667 136.353 202.48C135.891 203.292 134.14 204.273 134.14 205.023C134.14 205.774 139.037 206.066 139.037 207.744C139.037 209.422 131.563 210.288 131.563 211.277C131.563 212.611 135.251 212.09 133.447 215.04L133.438 215.049Z",
    fill: "url(#paint16_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10322_10919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 169,
    width: 53,
    height: 59
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M193.949 169.867H141.108V227.345H193.949V169.867Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10322_10919)"
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M176.193 185.325C176.193 187.684 177.402 189.6 178.886 189.6C180.37 189.6 181.578 187.684 181.578 185.325C181.578 182.967 180.37 181.05 178.886 181.05C177.402 181.05 176.193 182.967 176.193 185.325Z",
    fill: "url(#paint17_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M176.193 185.325C176.193 187.684 177.402 189.6 178.886 189.6C180.37 189.6 181.578 187.684 181.578 185.325C181.578 182.967 180.37 181.05 178.886 181.05C177.402 181.05 176.193 182.967 176.193 185.325Z",
    fill: "#A69B9B"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M174.504 185.325C174.504 188.231 175.989 190.581 177.819 190.581C179.65 190.581 181.134 188.231 181.134 185.325C181.134 182.419 179.65 180.069 177.819 180.069C175.989 180.069 174.504 182.419 174.504 185.325Z",
    fill: "url(#paint18_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M174.504 185.325C174.504 188.231 175.989 190.581 177.819 190.581C179.65 190.581 181.134 188.231 181.134 185.325C181.134 182.419 179.65 180.069 177.819 180.069C175.989 180.069 174.504 182.419 174.504 185.325Z",
    fill: "#463332"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M167.795 192.657H149.372V219.148H167.795V192.657Z",
    fill: "url(#paint19_linear_10322_10919)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M167.795 193.576H150.625V218.221H167.795V193.576Z",
    fill: "#FFF4EE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 204.148H152.03V204.996H161.192V204.148Z",
    fill: "#DDC8BA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 207.249H152.03V208.097H161.192V207.249Z",
    fill: "#DDC8BA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M156.926 205.712H152.03V206.56H156.926V205.712Z",
    fill: "#DDC8BA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 204.148H161.929V204.996H166.382V204.148Z",
    fill: "#DDC8BA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 205.712H157.664V206.56H166.382V205.712Z",
    fill: "#DDC8BA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 195.112H152.03V196.835H166.382V195.112Z",
    fill: "#DDC8BA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 198.398H152.03V199.246H161.192V198.398Z",
    fill: "#DDC8BA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 201.499H152.03V202.347H161.192V201.499Z",
    fill: "#DDC8BA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M156.926 199.962H152.03V200.81H156.926V199.962Z",
    fill: "#DDC8BA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 198.398H161.929V199.246H166.382V198.398Z",
    fill: "#DDC8BA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 199.962H157.664V200.81H166.382V199.962Z",
    fill: "#DDC8BA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M144.982 206.746C146.067 204.325 148.226 201.693 148.759 201.419C148.928 201.331 149.141 201.251 149.355 201.181V203.539C149.355 203.539 149.346 204.078 149.364 204.228C149.47 204.891 150.279 204.467 151.248 204.175C152.136 203.91 152.918 203.981 152.972 204.378C153.007 204.652 152.27 204.926 151.479 205.27C150.679 205.615 149.852 206.64 148.99 206.966C148.128 207.293 147.622 207.399 147.622 207.399C147.622 207.399 146.991 209.29 146.849 209.519L144.085 208.406L144.982 206.737V206.746Z",
    fill: "url(#paint20_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M144.236 208.132L144.138 208.442L146.849 209.537C146.991 209.316 147.622 207.417 147.622 207.417C147.622 207.417 148.137 207.311 148.99 206.984C149.852 206.657 150.679 205.633 151.479 205.288C152.278 204.944 153.007 204.67 152.972 204.396C152.972 204.352 152.927 204.334 152.9 204.299C152.581 204.67 151.479 204.864 151.008 205.12C150.457 205.421 150.092 205.995 149.328 206.551C148.866 206.887 147.853 206.931 147.275 207.072C146.697 207.205 145.764 207.62 144.662 207.32L144.218 208.141L144.236 208.132Z",
    fill: "#C3694D"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M142.521 224.987C139.259 221.427 143.756 207.497 143.756 207.497C143.756 207.497 146.004 206.879 147.524 209.882C147.524 209.882 148.377 219.122 146.884 221.789C145.391 224.457 142.521 224.978 142.521 224.978V224.987Z",
    fill: "url(#paint21_linear_10322_10919)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M174.06 199.353C176.335 198.505 180.485 204.255 185.035 210.474C191.363 219.122 194.26 224.227 191.443 226.551C188.315 229.13 183.764 223.141 178.663 217.117C173.562 211.084 168.31 201.482 174.06 199.353Z",
    fill: "url(#paint22_linear_10322_10919)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M165.475 172.712C165.475 172.712 163.751 171.608 161.592 173.286C158.65 175.574 160.01 179.019 159.601 181.466L164.489 176.21L165.475 172.712Z",
    fill: "url(#paint23_linear_10322_10919)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M172.914 187.869C172.434 189.848 172.265 191.517 172.105 193.84C171.883 197.109 173.616 198.716 173.616 198.716C171.501 199.264 167.59 199.591 165.315 198.469C165.315 198.469 167.102 197.939 166.426 193.452C165.964 190.378 172.905 187.869 172.905 187.869H172.914Z",
    fill: "url(#paint24_linear_10322_10919)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M163.325 174.593C163.112 177.243 167.111 178.63 169.075 179.972C172.096 182.022 171.829 185.475 171.829 185.475L173.758 185.149C173.758 185.149 178.583 186.668 179.792 186.323C180.619 177.101 178.379 172.773 171.75 171.263C165.973 169.947 163.494 172.517 163.325 174.593Z",
    fill: "url(#paint25_linear_10322_10919)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M181.907 233.387C180.352 227.195 180.379 223.971 180.219 218.662C180.076 214.13 180.778 210.447 179.01 203.345C177.668 197.948 172.532 198.292 167.999 198.16C166.169 198.107 163.929 198.637 162.418 199.635C159.032 201.87 156.74 208.804 157.602 211.843C158.49 214.97 160.534 215.164 160.525 219.828C160.525 223.732 158.597 227.539 157.14 233.157C156.882 235.277 173.696 237.927 181.898 233.378L181.907 233.387Z",
    fill: "url(#paint26_linear_10322_10919)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M164.667 198.619C164.667 198.619 166.08 200.474 170.416 200.395C173.411 200.342 175.135 198.902 175.135 198.902C175.135 198.902 170.825 196.747 164.667 198.619Z",
    fill: "url(#paint27_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M162.525 219.104C162.436 214.908 160.232 210.712 160.232 210.712L157.895 212.673C158.872 215.049 160.534 215.614 160.525 219.828C160.525 223.732 158.597 227.539 157.139 233.157C157.104 233.44 157.388 233.731 157.904 234.023C159.512 229.642 162.614 223.176 162.525 219.104Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M170.55 200.395C173.456 200.306 175.135 198.911 175.135 198.911C175.135 198.911 174.451 198.575 173.242 198.275C172.745 197.603 171.945 196.146 172.105 193.84C172.194 192.551 172.292 191.464 172.434 190.413L166.453 196.667C166.417 196.826 166.373 196.95 166.328 197.091C166.764 197.586 168.292 199.211 170.55 200.395Z",
    fill: "#AC6B53"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M164.818 199.194C162.365 198.134 157.202 203.611 151.541 209.538C143.676 217.779 139.952 222.717 142.858 225.34C146.084 228.247 151.719 222.558 157.975 216.878C164.231 211.198 170.994 201.888 164.818 199.203V199.194Z",
    fill: "url(#paint28_linear_10322_10919)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M179.979 181.704C179.979 184.893 182.254 192.392 180.192 194.874C179.206 196.058 175.126 197.233 170.932 197.339C166.8 197.445 162.552 196.491 161.032 195.369C157.966 193.108 160.463 188.002 160.961 183.541C161.459 179.08 163.103 172.888 171.572 173.772C179.054 174.549 179.979 181.704 179.979 181.704Z",
    fill: "url(#paint29_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M162.267 181.81C162.267 181.81 162.836 173.834 171.314 173.754C178.886 173.683 179.792 180.609 179.792 180.609C179.792 180.609 179.579 172.014 170.879 172.102C160.801 172.191 160.534 181.307 160.534 181.307L162.267 181.801V181.81Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M160.472 180.043C160.197 180.043 159.93 180.096 159.672 180.184C159.672 180.635 159.664 181.068 159.592 181.465L160.863 180.096C160.73 180.07 160.606 180.034 160.463 180.034L160.472 180.043Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M160.472 191.403C162.489 191.403 164.116 188.859 164.116 185.723C164.116 183.188 163.04 181.059 161.565 180.335C161.263 181.421 161.076 182.526 160.961 183.55C160.677 186.112 159.735 188.886 159.566 191.209C159.859 191.324 160.161 191.412 160.472 191.412V191.403Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M179.979 181.704C179.979 181.704 179.952 181.545 179.899 181.288C179.676 177.888 178.708 175.476 176.913 173.798C178.468 176.36 178.45 179.769 173.171 180.396C163.929 181.492 160.436 176.739 160.596 174.328C159.006 176.536 159.948 179.38 159.601 181.474L162.072 178.815C161.432 180.37 161.13 182.048 160.97 183.541C160.472 188.002 157.975 193.099 161.041 195.369C162.56 196.491 166.808 197.445 170.941 197.339C175.135 197.233 179.214 196.049 180.201 194.874C182.263 192.392 179.987 184.892 179.987 181.704H179.979Z",
    fill: "#491D17"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M161.814 181.209C161.814 181.209 162.4 173.233 171.092 173.153C178.859 173.083 179.783 180.008 179.783 180.008C179.783 180.008 179.561 171.413 170.638 171.502C160.303 171.59 160.028 180.706 160.028 180.706L161.805 181.201L161.814 181.209Z",
    fill: "url(#paint30_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M170.985 172.615C162.587 172.694 161.37 180.079 161.254 181.051L161.823 181.21C161.823 181.21 162.409 173.233 171.101 173.154C178.868 173.083 179.792 180.008 179.792 180.008C179.792 180.008 179.668 178.471 178.886 176.705C177.748 174.761 175.473 172.571 170.985 172.615Z",
    fill: "#463332"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M160.143 190.555C161.974 190.555 163.458 188.201 163.458 185.299C163.458 182.396 161.974 180.043 160.143 180.043C158.312 180.043 156.828 182.396 156.828 185.299C156.828 188.201 158.312 190.555 160.143 190.555Z",
    fill: "url(#paint31_linear_10322_10919)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M161.734 185.326C161.734 187.685 160.525 189.601 159.041 189.601C157.557 189.601 156.349 187.685 156.349 185.326C156.349 182.968 157.557 181.051 159.041 181.051C160.525 181.051 161.734 182.968 161.734 185.326Z",
    fill: "url(#paint32_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M160.143 180.043C160.063 180.043 160.001 180.069 159.921 180.078C161.467 180.405 162.658 182.49 162.658 185.025C162.658 187.799 161.245 190.042 159.494 190.042C159.068 190.042 158.659 189.901 158.286 189.654C158.819 190.219 159.45 190.555 160.143 190.555C161.974 190.555 163.458 188.205 163.458 185.299C163.458 182.393 161.974 180.043 160.143 180.043Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M159.041 181.051C158.544 181.051 158.081 181.28 157.673 181.66C157.921 181.519 158.179 181.422 158.464 181.422C159.717 181.422 160.739 183.038 160.739 185.035C160.739 187.031 159.717 188.647 158.464 188.647C157.664 188.647 156.962 187.985 156.553 186.987C156.962 188.533 157.921 189.61 159.041 189.61C160.534 189.61 161.734 187.693 161.734 185.335C161.734 182.976 160.525 181.06 159.041 181.06V181.051Z",
    fill: "#A69B9B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M158.561 182.137C159.814 182.349 158.321 184.566 157.655 184.469C156.615 184.319 157.468 181.952 158.561 182.137Z",
    fill: "#FFF7E6"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M157.264 184.814C158.046 184.69 157.753 185.847 157.379 185.892C156.802 185.962 156.651 184.911 157.264 184.814Z",
    fill: "#FFF7E6"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M190.749 220.906C190.003 233.591 185.408 240.887 176.246 240.887C167.084 240.887 163.342 233.591 164.089 220.906C164.835 208.222 168.257 194.963 178.948 194.963C189.639 194.963 191.505 208.222 190.758 220.906H190.749Z",
    fill: "url(#paint33_linear_10322_10919)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M192.767 220.906C192.02 233.591 187.426 240.887 178.263 240.887C169.101 240.887 165.36 233.591 166.106 220.906C166.853 208.222 170.274 194.963 180.965 194.963C191.656 194.963 193.522 208.222 192.776 220.906H192.767Z",
    fill: "url(#paint34_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M185.089 195.811C190.376 199.759 191.363 209.591 190.803 219.113C190.083 231.391 185.631 238.458 176.753 238.458C172.576 238.458 169.581 236.876 167.635 233.935C169.492 238.44 172.967 240.887 178.255 240.887C187.417 240.887 192.02 233.591 192.758 220.906C193.389 210.085 192.109 198.867 185.08 195.802L185.089 195.811Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M161.378 213.451C161.378 213.451 162.489 210.783 162.223 210.138C162.223 210.138 158.161 214.317 157.539 214.873C151.861 220.032 146.449 226.038 143.525 223.397C140.841 220.977 143.009 211.79 144.298 207.453C143.96 207.453 143.756 207.506 143.756 207.506C143.756 207.506 139.499 220.721 142.307 224.678C142.352 224.749 142.396 224.828 142.45 224.899C142.476 224.925 142.485 224.97 142.512 224.996H142.529C142.627 225.12 142.725 225.235 142.849 225.349C146.075 228.255 151.71 222.567 157.966 216.887C158.659 216.26 160.525 214.44 161.378 213.46V213.451Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M147.719 213.3C147.648 211.366 147.515 209.89 147.515 209.89C146.004 206.878 143.747 207.505 143.747 207.505C143.747 207.505 139.25 221.435 142.512 224.995C140.619 221.303 145.942 215.552 147.648 213.733L147.711 213.309L147.719 213.3Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M149.87 204.581C149.87 204.581 149.87 204.581 149.879 204.581C149.603 204.608 149.417 204.528 149.372 204.237C149.346 204.087 149.372 203.548 149.372 203.548V202.152C149.292 202.214 148.501 202.965 148.546 203.663C148.599 204.493 149.204 204.705 149.87 204.59V204.581Z",
    fill: "#C3694D"
  })))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9597 225.817V220.526H69.0177V218.998H112.439C113.194 218.998 113.807 219.608 113.807 220.358V225.994C113.807 226.745 113.194 227.354 112.439 227.354H69.0177V225.826H69.9597V225.817Z",
    fill: "url(#paint35_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M112.439 218.998H92.6033V227.346H112.439C113.194 227.346 113.807 226.736 113.807 225.985V220.35C113.807 219.599 113.194 218.989 112.439 218.989V218.998Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M111.763 225.817H71.115V220.526H111.763C112.243 220.526 112.625 220.915 112.625 221.383V224.952C112.625 225.429 112.234 225.809 111.763 225.809V225.817Z",
    fill: "#60578F"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M110.608 225.817H69.9598V220.526H110.608C111.088 220.526 111.47 220.915 111.47 221.383V224.952C111.47 225.429 111.079 225.809 110.608 225.809V225.817Z",
    fill: "#CEB6AA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M91.697 220.526H69.9598V225.817H91.697V220.526Z",
    fill: "#CEB6AA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M91.697 220.526H69.9598V225.817H91.697V220.526Z",
    fill: "#FFE6D6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9594 220.526H110.599C111.079 220.526 111.461 220.915 111.461 221.383V222.602C111.461 222.125 111.07 221.745 110.599 221.745H90.9594V220.526Z",
    fill: "#B29B93"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M110.004 222.823C110.004 222.823 109.435 222.867 108.573 222.911C107.711 222.956 106.565 222.973 105.418 222.982C104.272 222.973 103.125 222.956 102.263 222.911C101.401 222.867 100.833 222.823 100.833 222.823C100.833 222.823 101.41 222.779 102.263 222.735C103.125 222.691 104.272 222.673 105.418 222.664C106.565 222.673 107.711 222.691 108.573 222.735C109.435 222.779 110.004 222.823 110.004 222.823Z",
    fill: "#B29B93"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M107.276 224.846C107.276 224.846 106.431 224.882 105.178 224.935C103.916 224.979 102.237 224.997 100.557 225.005C98.8775 224.997 97.1979 224.979 95.936 224.935C94.6741 224.882 93.8387 224.846 93.8387 224.846C93.8387 224.846 94.683 224.811 95.936 224.758C97.1979 224.714 98.8775 224.696 100.557 224.688C102.237 224.696 103.916 224.714 105.178 224.758C106.44 224.811 107.276 224.846 107.276 224.846Z",
    fill: "#B29B93"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6128 223.795C90.6128 223.795 89.5375 223.83 87.929 223.874C86.3204 223.909 84.1787 223.927 82.037 223.936C79.8953 223.927 77.7447 223.909 76.145 223.874C74.5365 223.83 73.4612 223.795 73.4612 223.795C73.4612 223.795 74.5365 223.759 76.145 223.715C77.7535 223.68 79.8953 223.662 82.037 223.653C84.1787 223.662 86.3293 223.68 87.929 223.715C89.5375 223.759 90.6128 223.795 90.6128 223.795Z",
    fill: "#CEB6AA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2245 222.55C78.2245 222.55 77.7624 222.594 77.0781 222.629C76.3939 222.664 75.4696 222.682 74.5543 222.691C73.6389 222.682 72.7236 222.664 72.0304 222.629C71.3461 222.594 70.884 222.55 70.884 222.55C70.884 222.55 71.3461 222.505 72.0304 222.47C72.7147 222.435 73.6389 222.417 74.5543 222.408C75.4696 222.417 76.385 222.435 77.0781 222.47C77.7624 222.505 78.2245 222.55 78.2245 222.55Z",
    fill: "#CEB6AA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8312 224.899C87.8312 224.899 87.1291 224.934 86.0805 224.979C85.0318 225.014 83.6277 225.032 82.2325 225.04C80.8284 225.032 79.4331 225.014 78.3845 224.979C77.3359 224.934 76.6338 224.899 76.6338 224.899L78.3845 224.82C79.4331 224.784 80.8373 224.767 82.2325 224.758C83.6366 224.767 85.0318 224.784 86.0805 224.82C87.1291 224.864 87.8312 224.899 87.8312 224.899Z",
    fill: "#CEB6AA"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M91.697 220.526H69.9598V221.728H91.697V220.526Z",
    fill: "#CEB6AA"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M106.734 214.502V211.225H107.48V210.023H73.2924C72.697 210.023 72.2171 210.5 72.2171 211.092V214.643C72.2171 215.235 72.697 215.712 73.2924 215.712H107.48V214.511H106.734V214.502Z",
    fill: "url(#paint36_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8256 211.225H105.827V214.502H73.8256C73.4524 214.502 73.1414 214.201 73.1414 213.822V211.896C73.1414 211.525 73.4435 211.216 73.8256 211.216V211.225Z",
    fill: "#A0335D"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7321 211.225H106.734V214.502H74.7321C74.3588 214.502 74.0478 214.201 74.0478 213.822V211.896C74.0478 211.525 74.3499 211.216 74.7321 211.216V211.225Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M107.48 211.225V210.023H90.0352V215.712H107.48V214.511H106.734V211.234H107.48V211.225Z",
    fill: "#A0335D"
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M106.734 211.225H89.6175V214.502H106.734V211.225Z",
    fill: "#CEB6AA"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M106.734 211.225H89.6175V214.502H106.734V211.225Z",
    fill: "#CEB6AA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1951 211.225H74.7321C74.3588 211.225 74.0478 211.525 74.0478 211.905V212.868C74.0478 212.497 74.3499 212.187 74.7321 212.187H90.1951V211.225Z",
    fill: "#CEB6AA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2032 212.85L76.3318 212.78C77.0072 212.744 77.9136 212.735 78.8112 212.718C79.7177 212.727 80.6152 212.735 81.2906 212.771C81.966 212.815 82.4193 212.841 82.4193 212.841C82.4193 212.841 81.966 212.868 81.2906 212.912C80.6152 212.947 79.7088 212.956 78.8112 212.965C77.9048 212.956 77.0072 212.947 76.3318 212.903C75.6564 212.859 75.2032 212.833 75.2032 212.833V212.85Z",
    fill: "#CEB6AA"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3537 213.734C77.3537 213.734 78.0113 213.708 79.0066 213.663C80.0019 213.628 81.3172 213.619 82.6413 213.602C83.9655 213.61 85.2896 213.619 86.276 213.655C87.2714 213.699 87.929 213.725 87.929 213.725C87.929 213.725 87.2714 213.752 86.276 213.796C85.2807 213.831 83.9655 213.84 82.6413 213.849C81.3172 213.84 79.9931 213.831 79.0066 213.787C78.0113 213.743 77.3537 213.716 77.3537 213.716V213.734Z",
    fill: "#CEB6AA"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4707 212.912C90.4707 212.912 91.3149 212.877 92.5769 212.832C93.8388 212.788 95.5273 212.779 97.2158 212.771C98.9043 212.779 100.593 212.797 101.855 212.832C103.117 212.885 103.961 212.912 103.961 212.912C103.961 212.912 103.117 212.947 101.855 212.991C100.593 213.036 98.9043 213.044 97.2158 213.053C95.5273 213.044 93.8388 213.027 92.5769 212.991C91.3149 212.938 90.4707 212.912 90.4707 212.912Z",
    fill: "#B29B93"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7584 213.769C95.7584 213.769 97.9623 213.636 100.166 213.645C102.37 213.636 104.574 213.769 104.574 213.769C104.574 213.769 102.37 213.901 100.166 213.892C97.9623 213.901 95.7584 213.769 95.7584 213.769Z",
    fill: "#B29B93"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M106.734 211.225H89.6175V212.17H106.734V211.225Z",
    fill: "#B29B93"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6843 218.274V216.463H69V215.668H112.812C113.354 215.668 113.798 216.039 113.798 216.498V218.238C113.798 218.698 113.354 219.069 112.812 219.069H69V218.274H69.6843Z",
    fill: "url(#paint37_linear_10322_10919)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M112.812 215.668H91.1282V219.069H112.812C113.354 219.069 113.798 218.698 113.798 218.238V216.498C113.798 216.039 113.354 215.668 112.812 215.668Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M112.332 218.273H70.5285V216.463H112.332C112.679 216.463 112.954 216.745 112.954 217.081V217.655C112.954 218 112.67 218.273 112.332 218.273Z",
    fill: "#AA2424"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M111.497 218.273H69.6932V216.463H111.497C111.843 216.463 112.119 216.745 112.119 217.081V217.655C112.119 218 111.835 218.273 111.497 218.273Z",
    fill: "#CEB6AA"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5192 216.463H69.6843V218.274H91.5192V216.463Z",
    fill: "#CEB6AA"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5192 216.463H69.6843V218.274H91.5192V216.463Z",
    fill: "#FFE6D6"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9861 216.463H111.497C111.843 216.463 112.119 216.746 112.119 217.081V217.965C112.119 217.62 111.835 217.346 111.497 217.346H90.9861V216.463Z",
    fill: "#B29B93"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5192 216.463H69.6843V217.329H91.5192V216.463Z",
    fill: "#CEB6AA"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M29.62 64V52.06H25.54V50H36.28V52.06H32.18V64H29.62ZM40.9195 64.24C39.9195 64.24 39.0329 64.0267 38.2595 63.6C37.4862 63.1733 36.8795 62.5733 36.4395 61.8C35.9995 61.0267 35.7795 60.1333 35.7795 59.12C35.7795 58.0933 35.9929 57.18 36.4195 56.38C36.8595 55.58 37.4595 54.96 38.2195 54.52C38.9929 54.0667 39.8995 53.84 40.9395 53.84C41.9129 53.84 42.7729 54.0533 43.5195 54.48C44.2662 54.9067 44.8462 55.4933 45.2595 56.24C45.6862 56.9733 45.8995 57.7933 45.8995 58.7C45.8995 58.8467 45.8929 59 45.8795 59.16C45.8795 59.32 45.8729 59.4867 45.8595 59.66H38.3195C38.3729 60.4333 38.6395 61.04 39.1195 61.48C39.6129 61.92 40.2062 62.14 40.8995 62.14C41.4195 62.14 41.8529 62.0267 42.1995 61.8C42.5595 61.56 42.8262 61.2533 42.9995 60.88H45.5995C45.4129 61.5067 45.0995 62.08 44.6595 62.6C44.2329 63.1067 43.6995 63.5067 43.0595 63.8C42.4329 64.0933 41.7195 64.24 40.9195 64.24ZM40.9395 55.92C40.3129 55.92 39.7595 56.1 39.2795 56.46C38.7995 56.8067 38.4929 57.34 38.3595 58.06H43.2995C43.2595 57.4067 43.0195 56.8867 42.5795 56.5C42.1395 56.1133 41.5929 55.92 40.9395 55.92ZM51.2527 64.24C50.3993 64.24 49.6993 64.1067 49.1527 63.84C48.606 63.56 48.1993 63.1933 47.9327 62.74C47.666 62.2867 47.5327 61.7867 47.5327 61.24C47.5327 60.32 47.8927 59.5733 48.6127 59C49.3327 58.4267 50.4127 58.14 51.8527 58.14H54.3727V57.9C54.3727 57.22 54.1793 56.72 53.7927 56.4C53.406 56.08 52.926 55.92 52.3527 55.92C51.8327 55.92 51.3793 56.0467 50.9927 56.3C50.606 56.54 50.366 56.9 50.2727 57.38H47.7727C47.8393 56.66 48.0793 56.0333 48.4927 55.5C48.9193 54.9667 49.466 54.56 50.1327 54.28C50.7993 53.9867 51.546 53.84 52.3727 53.84C53.786 53.84 54.8993 54.1933 55.7127 54.9C56.526 55.6067 56.9327 56.6067 56.9327 57.9V64H54.7527L54.5127 62.4C54.2193 62.9333 53.806 63.3733 53.2727 63.72C52.7527 64.0667 52.0793 64.24 51.2527 64.24ZM51.8327 62.24C52.566 62.24 53.1327 62 53.5327 61.52C53.946 61.04 54.206 60.4467 54.3127 59.74H52.1327C51.4527 59.74 50.966 59.8667 50.6727 60.12C50.3793 60.36 50.2327 60.66 50.2327 61.02C50.2327 61.4067 50.3793 61.7067 50.6727 61.92C50.966 62.1333 51.3527 62.24 51.8327 62.24ZM64.0156 64.24C63.0023 64.24 62.109 64.02 61.3356 63.58C60.5623 63.14 59.949 62.5267 59.4956 61.74C59.0556 60.9533 58.8356 60.0533 58.8356 59.04C58.8356 58.0267 59.0556 57.1267 59.4956 56.34C59.949 55.5533 60.5623 54.94 61.3356 54.5C62.109 54.06 63.0023 53.84 64.0156 53.84C65.2823 53.84 66.349 54.1733 67.2156 54.84C68.0823 55.4933 68.6356 56.4 68.8756 57.56H66.1756C66.0423 57.08 65.7756 56.7067 65.3756 56.44C64.989 56.16 64.529 56.02 63.9956 56.02C63.289 56.02 62.689 56.2867 62.1956 56.82C61.7023 57.3533 61.4556 58.0933 61.4556 59.04C61.4556 59.9867 61.7023 60.7267 62.1956 61.26C62.689 61.7933 63.289 62.06 63.9956 62.06C64.529 62.06 64.989 61.9267 65.3756 61.66C65.7756 61.3933 66.0423 61.0133 66.1756 60.52H68.8756C68.6356 61.64 68.0823 62.54 67.2156 63.22C66.349 63.9 65.2823 64.24 64.0156 64.24ZM70.9278 64V49.6H73.4878V55.6C73.8211 55.0533 74.2678 54.6267 74.8278 54.32C75.4011 54 76.0545 53.84 76.7878 53.84C78.0145 53.84 78.9611 54.2267 79.6278 55C80.3078 55.7733 80.6478 56.9067 80.6478 58.4V64H78.1078V58.64C78.1078 57.7867 77.9345 57.1333 77.5878 56.68C77.2545 56.2267 76.7211 56 75.9878 56C75.2678 56 74.6678 56.2533 74.1878 56.76C73.7211 57.2667 73.4878 57.9733 73.4878 58.88V64H70.9278ZM87.6958 64.24C86.6958 64.24 85.8091 64.0267 85.0358 63.6C84.2624 63.1733 83.6558 62.5733 83.2158 61.8C82.7758 61.0267 82.5558 60.1333 82.5558 59.12C82.5558 58.0933 82.7691 57.18 83.1958 56.38C83.6358 55.58 84.2358 54.96 84.9958 54.52C85.7691 54.0667 86.6758 53.84 87.7158 53.84C88.6891 53.84 89.5491 54.0533 90.2958 54.48C91.0424 54.9067 91.6224 55.4933 92.0358 56.24C92.4624 56.9733 92.6758 57.7933 92.6758 58.7C92.6758 58.8467 92.6691 59 92.6558 59.16C92.6558 59.32 92.6491 59.4867 92.6358 59.66H85.0958C85.1491 60.4333 85.4158 61.04 85.8958 61.48C86.3891 61.92 86.9824 62.14 87.6758 62.14C88.1958 62.14 88.6291 62.0267 88.9758 61.8C89.3358 61.56 89.6024 61.2533 89.7758 60.88H92.3758C92.1891 61.5067 91.8758 62.08 91.4358 62.6C91.0091 63.1067 90.4758 63.5067 89.8358 63.8C89.2091 64.0933 88.4958 64.24 87.6958 64.24ZM87.7158 55.92C87.0891 55.92 86.5358 56.1 86.0558 56.46C85.5758 56.8067 85.2691 57.34 85.1358 58.06H90.0758C90.0358 57.4067 89.7958 56.8867 89.3558 56.5C88.9158 56.1133 88.3691 55.92 87.7158 55.92ZM94.6089 64V54.08H96.8889L97.1289 55.94C97.4889 55.3 97.9756 54.7933 98.5889 54.42C99.2156 54.0333 99.9489 53.84 100.789 53.84V56.54H100.069C99.5089 56.54 99.0089 56.6267 98.5689 56.8C98.1289 56.9733 97.7822 57.2733 97.5289 57.7C97.2889 58.1267 97.1689 58.72 97.1689 59.48V64H94.6089ZM25.46 90L30.58 76H33.46L38.58 90H35.86L34.74 86.76H29.28L28.14 90H25.46ZM29.98 84.76H34.04L32 78.94L29.98 84.76ZM44.2034 90.24C43.3234 90.24 42.5501 90.1 41.8834 89.82C41.2168 89.5267 40.6834 89.1267 40.2834 88.62C39.8834 88.1133 39.6434 87.5267 39.5634 86.86H42.1434C42.2234 87.2467 42.4368 87.58 42.7834 87.86C43.1434 88.1267 43.6034 88.26 44.1634 88.26C44.7234 88.26 45.1301 88.1467 45.3834 87.92C45.6501 87.6933 45.7834 87.4333 45.7834 87.14C45.7834 86.7133 45.5968 86.4267 45.2234 86.28C44.8501 86.12 44.3301 85.9667 43.6634 85.82C43.2368 85.7267 42.8034 85.6133 42.3634 85.48C41.9234 85.3467 41.5168 85.18 41.1434 84.98C40.7834 84.7667 40.4901 84.5 40.2634 84.18C40.0368 83.8467 39.9234 83.44 39.9234 82.96C39.9234 82.08 40.2701 81.34 40.9634 80.74C41.6701 80.14 42.6568 79.84 43.9234 79.84C45.0968 79.84 46.0301 80.1133 46.7234 80.66C47.4301 81.2067 47.8501 81.96 47.9834 82.92H45.5634C45.4168 82.1867 44.8634 81.82 43.9034 81.82C43.4234 81.82 43.0501 81.9133 42.7834 82.1C42.5301 82.2867 42.4034 82.52 42.4034 82.8C42.4034 83.0933 42.5968 83.3267 42.9834 83.5C43.3701 83.6733 43.8834 83.8333 44.5234 83.98C45.2168 84.14 45.8501 84.32 46.4234 84.52C47.0101 84.7067 47.4768 84.9933 47.8234 85.38C48.1701 85.7533 48.3434 86.2933 48.3434 87C48.3568 87.6133 48.1968 88.1667 47.8634 88.66C47.5301 89.1533 47.0501 89.54 46.4234 89.82C45.7968 90.1 45.0568 90.24 44.2034 90.24ZM54.4912 90.24C53.6112 90.24 52.8379 90.1 52.1712 89.82C51.5046 89.5267 50.9712 89.1267 50.5712 88.62C50.1712 88.1133 49.9312 87.5267 49.8512 86.86H52.4312C52.5112 87.2467 52.7246 87.58 53.0712 87.86C53.4312 88.1267 53.8912 88.26 54.4512 88.26C55.0112 88.26 55.4179 88.1467 55.6712 87.92C55.9379 87.6933 56.0712 87.4333 56.0712 87.14C56.0712 86.7133 55.8846 86.4267 55.5112 86.28C55.1379 86.12 54.6179 85.9667 53.9512 85.82C53.5246 85.7267 53.0912 85.6133 52.6512 85.48C52.2112 85.3467 51.8046 85.18 51.4312 84.98C51.0712 84.7667 50.7779 84.5 50.5512 84.18C50.3246 83.8467 50.2112 83.44 50.2112 82.96C50.2112 82.08 50.5579 81.34 51.2512 80.74C51.9579 80.14 52.9446 79.84 54.2112 79.84C55.3846 79.84 56.3179 80.1133 57.0113 80.66C57.7179 81.2067 58.1379 81.96 58.2712 82.92H55.8513C55.7046 82.1867 55.1512 81.82 54.1912 81.82C53.7112 81.82 53.3379 81.9133 53.0712 82.1C52.8179 82.2867 52.6912 82.52 52.6912 82.8C52.6912 83.0933 52.8846 83.3267 53.2712 83.5C53.6579 83.6733 54.1712 83.8333 54.8112 83.98C55.5046 84.14 56.1379 84.32 56.7112 84.52C57.2979 84.7067 57.7646 84.9933 58.1113 85.38C58.4579 85.7533 58.6313 86.2933 58.6313 87C58.6446 87.6133 58.4846 88.1667 58.1512 88.66C57.8179 89.1533 57.3379 89.54 56.7112 89.82C56.0846 90.1 55.3446 90.24 54.4912 90.24ZM62.0591 78.54C61.5924 78.54 61.2057 78.4 60.8991 78.12C60.6057 77.84 60.4591 77.4867 60.4591 77.06C60.4591 76.6333 60.6057 76.2867 60.8991 76.02C61.2057 75.74 61.5924 75.6 62.0591 75.6C62.5257 75.6 62.9057 75.74 63.1991 76.02C63.5057 76.2867 63.6591 76.6333 63.6591 77.06C63.6591 77.4867 63.5057 77.84 63.1991 78.12C62.9057 78.4 62.5257 78.54 62.0591 78.54ZM60.7791 90V80.08H63.3391V90H60.7791ZM69.8911 90.24C69.0111 90.24 68.2378 90.1 67.5711 89.82C66.9044 89.5267 66.3711 89.1267 65.9711 88.62C65.5711 88.1133 65.3311 87.5267 65.2511 86.86H67.8311C67.9111 87.2467 68.1244 87.58 68.4711 87.86C68.8311 88.1267 69.2911 88.26 69.8511 88.26C70.4111 88.26 70.8178 88.1467 71.0711 87.92C71.3378 87.6933 71.4711 87.4333 71.4711 87.14C71.4711 86.7133 71.2844 86.4267 70.9111 86.28C70.5378 86.12 70.0178 85.9667 69.3511 85.82C68.9244 85.7267 68.4911 85.6133 68.0511 85.48C67.6111 85.3467 67.2044 85.18 66.8311 84.98C66.4711 84.7667 66.1778 84.5 65.9511 84.18C65.7244 83.8467 65.6111 83.44 65.6111 82.96C65.6111 82.08 65.9578 81.34 66.6511 80.74C67.3578 80.14 68.3444 79.84 69.6111 79.84C70.7844 79.84 71.7178 80.1133 72.4111 80.66C73.1178 81.2067 73.5378 81.96 73.6711 82.92H71.2511C71.1044 82.1867 70.5511 81.82 69.5911 81.82C69.1111 81.82 68.7378 81.9133 68.4711 82.1C68.2178 82.2867 68.0911 82.52 68.0911 82.8C68.0911 83.0933 68.2844 83.3267 68.6711 83.5C69.0578 83.6733 69.5711 83.8333 70.2111 83.98C70.9044 84.14 71.5378 84.32 72.1111 84.52C72.6978 84.7067 73.1644 84.9933 73.5111 85.38C73.8578 85.7533 74.0311 86.2933 74.0311 87C74.0444 87.6133 73.8844 88.1667 73.5511 88.66C73.2178 89.1533 72.7378 89.54 72.1111 89.82C71.4844 90.1 70.7444 90.24 69.8911 90.24ZM80.1864 90C79.1464 90 78.3131 89.7467 77.6864 89.24C77.0597 88.7333 76.7464 87.8333 76.7464 86.54V82.22H75.0464V80.08H76.7464L77.0464 77.42H79.3064V80.08H81.9864V82.22H79.3064V86.56C79.3064 87.04 79.4064 87.3733 79.6064 87.56C79.8197 87.7333 80.1797 87.82 80.6864 87.82H81.9264V90H80.1864ZM87.3844 90.24C86.531 90.24 85.831 90.1067 85.2844 89.84C84.7377 89.56 84.331 89.1933 84.0644 88.74C83.7977 88.2867 83.6644 87.7867 83.6644 87.24C83.6644 86.32 84.0244 85.5733 84.7444 85C85.4644 84.4267 86.5444 84.14 87.9844 84.14H90.5044V83.9C90.5044 83.22 90.311 82.72 89.9244 82.4C89.5377 82.08 89.0577 81.92 88.4844 81.92C87.9644 81.92 87.511 82.0467 87.1244 82.3C86.7377 82.54 86.4977 82.9 86.4044 83.38H83.9044C83.971 82.66 84.211 82.0333 84.6244 81.5C85.051 80.9667 85.5977 80.56 86.2644 80.28C86.931 79.9867 87.6777 79.84 88.5044 79.84C89.9177 79.84 91.031 80.1933 91.8444 80.9C92.6577 81.6067 93.0644 82.6067 93.0644 83.9V90H90.8844L90.6444 88.4C90.351 88.9333 89.9377 89.3733 89.4044 89.72C88.8844 90.0667 88.211 90.24 87.3844 90.24ZM87.9644 88.24C88.6977 88.24 89.2644 88 89.6644 87.52C90.0777 87.04 90.3377 86.4467 90.4444 85.74H88.2644C87.5844 85.74 87.0977 85.8667 86.8044 86.12C86.511 86.36 86.3644 86.66 86.3644 87.02C86.3644 87.4067 86.511 87.7067 86.8044 87.92C87.0977 88.1333 87.4844 88.24 87.9644 88.24ZM95.2873 90V80.08H97.5473L97.7473 81.76C98.054 81.1733 98.494 80.7067 99.0673 80.36C99.654 80.0133 100.341 79.84 101.127 79.84C102.354 79.84 103.307 80.2267 103.987 81C104.667 81.7733 105.007 82.9067 105.007 84.4V90H102.447V84.64C102.447 83.7867 102.274 83.1333 101.927 82.68C101.581 82.2267 101.041 82 100.307 82C99.5873 82 98.994 82.2533 98.5273 82.76C98.074 83.2667 97.8473 83.9733 97.8473 84.88V90H95.2873ZM112.095 90.24C111.082 90.24 110.189 90.02 109.415 89.58C108.642 89.14 108.029 88.5267 107.575 87.74C107.135 86.9533 106.915 86.0533 106.915 85.04C106.915 84.0267 107.135 83.1267 107.575 82.34C108.029 81.5533 108.642 80.94 109.415 80.5C110.189 80.06 111.082 79.84 112.095 79.84C113.362 79.84 114.429 80.1733 115.295 80.84C116.162 81.4933 116.715 82.4 116.955 83.56H114.255C114.122 83.08 113.855 82.7067 113.455 82.44C113.069 82.16 112.609 82.02 112.075 82.02C111.369 82.02 110.769 82.2867 110.275 82.82C109.782 83.3533 109.535 84.0933 109.535 85.04C109.535 85.9867 109.782 86.7267 110.275 87.26C110.769 87.7933 111.369 88.06 112.075 88.06C112.609 88.06 113.069 87.9267 113.455 87.66C113.855 87.3933 114.122 87.0133 114.255 86.52H116.955C116.715 87.64 116.162 88.54 115.295 89.22C114.429 89.9 113.362 90.24 112.095 90.24ZM123.827 90.24C122.827 90.24 121.941 90.0267 121.167 89.6C120.394 89.1733 119.787 88.5733 119.347 87.8C118.907 87.0267 118.687 86.1333 118.687 85.12C118.687 84.0933 118.901 83.18 119.327 82.38C119.767 81.58 120.367 80.96 121.127 80.52C121.901 80.0667 122.807 79.84 123.847 79.84C124.821 79.84 125.681 80.0533 126.427 80.48C127.174 80.9067 127.754 81.4933 128.167 82.24C128.594 82.9733 128.807 83.7933 128.807 84.7C128.807 84.8467 128.801 85 128.787 85.16C128.787 85.32 128.781 85.4867 128.767 85.66H121.227C121.281 86.4333 121.547 87.04 122.027 87.48C122.521 87.92 123.114 88.14 123.807 88.14C124.327 88.14 124.761 88.0267 125.107 87.8C125.467 87.56 125.734 87.2533 125.907 86.88H128.507C128.321 87.5067 128.007 88.08 127.567 88.6C127.141 89.1067 126.607 89.5067 125.967 89.8C125.341 90.0933 124.627 90.24 123.827 90.24ZM123.847 81.92C123.221 81.92 122.667 82.1 122.187 82.46C121.707 82.8067 121.401 83.34 121.267 84.06H126.207C126.167 83.4067 125.927 82.8867 125.487 82.5C125.047 82.1133 124.501 81.92 123.847 81.92ZM31.14 116.24C30.1133 116.24 29.2067 116.067 28.42 115.72C27.6333 115.36 27.0133 114.853 26.56 114.2C26.1067 113.533 25.8733 112.727 25.86 111.78H28.56C28.5867 112.433 28.82 112.987 29.26 113.44C29.7133 113.88 30.3333 114.1 31.12 114.1C31.8 114.1 32.34 113.94 32.74 113.62C33.14 113.287 33.34 112.847 33.34 112.3C33.34 111.727 33.16 111.28 32.8 110.96C32.4533 110.64 31.9867 110.38 31.4 110.18C30.8133 109.98 30.1867 109.767 29.52 109.54C28.44 109.167 27.6133 108.687 27.04 108.1C26.48 107.513 26.2 106.733 26.2 105.76C26.1867 104.933 26.38 104.227 26.78 103.64C27.1933 103.04 27.7533 102.58 28.46 102.26C29.1667 101.927 29.98 101.76 30.9 101.76C31.8333 101.76 32.6533 101.927 33.36 102.26C34.08 102.593 34.64 103.06 35.04 103.66C35.4533 104.26 35.6733 104.973 35.7 105.8H32.96C32.9467 105.307 32.7533 104.873 32.38 104.5C32.02 104.113 31.5133 103.92 30.86 103.92C30.3 103.907 29.8267 104.047 29.44 104.34C29.0667 104.62 28.88 105.033 28.88 105.58C28.88 106.047 29.0267 106.42 29.32 106.7C29.6133 106.967 30.0133 107.193 30.52 107.38C31.0267 107.567 31.6067 107.767 32.26 107.98C32.9533 108.22 33.5867 108.5 34.16 108.82C34.7333 109.14 35.1933 109.567 35.54 110.1C35.8867 110.62 36.06 111.293 36.06 112.12C36.06 112.853 35.8733 113.533 35.5 114.16C35.1267 114.787 34.5733 115.293 33.84 115.68C33.1067 116.053 32.2067 116.24 31.14 116.24ZM39.2536 120.4L41.5536 115.34H40.9536L37.0936 106.08H39.8736L42.6536 113.06L45.5536 106.08H48.2736L41.9736 120.4H39.2536ZM53.3389 116.24C52.4589 116.24 51.6856 116.1 51.0189 115.82C50.3522 115.527 49.8189 115.127 49.4189 114.62C49.0189 114.113 48.7789 113.527 48.6989 112.86H51.2789C51.3589 113.247 51.5722 113.58 51.9189 113.86C52.2789 114.127 52.7389 114.26 53.2989 114.26C53.8589 114.26 54.2656 114.147 54.5189 113.92C54.7856 113.693 54.9189 113.433 54.9189 113.14C54.9189 112.713 54.7322 112.427 54.3589 112.28C53.9856 112.12 53.4656 111.967 52.7989 111.82C52.3722 111.727 51.9389 111.613 51.4989 111.48C51.0589 111.347 50.6522 111.18 50.2789 110.98C49.9189 110.767 49.6256 110.5 49.3989 110.18C49.1722 109.847 49.0589 109.44 49.0589 108.96C49.0589 108.08 49.4056 107.34 50.0989 106.74C50.8056 106.14 51.7922 105.84 53.0589 105.84C54.2322 105.84 55.1656 106.113 55.8589 106.66C56.5656 107.207 56.9856 107.96 57.1189 108.92H54.6989C54.5522 108.187 53.9989 107.82 53.0389 107.82C52.5589 107.82 52.1856 107.913 51.9189 108.1C51.6656 108.287 51.5389 108.52 51.5389 108.8C51.5389 109.093 51.7322 109.327 52.1189 109.5C52.5056 109.673 53.0189 109.833 53.6589 109.98C54.3522 110.14 54.9856 110.32 55.5589 110.52C56.1456 110.707 56.6122 110.993 56.9589 111.38C57.3056 111.753 57.4789 112.293 57.4789 113C57.4922 113.613 57.3322 114.167 56.9989 114.66C56.6656 115.153 56.1856 115.54 55.5589 115.82C54.9322 116.1 54.1922 116.24 53.3389 116.24ZM63.6342 116C62.5942 116 61.7609 115.747 61.1342 115.24C60.5076 114.733 60.1942 113.833 60.1942 112.54V108.22H58.4942V106.08H60.1942L60.4942 103.42H62.7542V106.08H65.4342V108.22H62.7542V112.56C62.7542 113.04 62.8542 113.373 63.0542 113.56C63.2676 113.733 63.6276 113.82 64.1342 113.82H65.3742V116H63.6342ZM71.9783 116.24C70.9783 116.24 70.0916 116.027 69.3183 115.6C68.5449 115.173 67.9383 114.573 67.4983 113.8C67.0583 113.027 66.8383 112.133 66.8383 111.12C66.8383 110.093 67.0516 109.18 67.4783 108.38C67.9183 107.58 68.5183 106.96 69.2783 106.52C70.0516 106.067 70.9583 105.84 71.9983 105.84C72.9716 105.84 73.8316 106.053 74.5783 106.48C75.3249 106.907 75.9049 107.493 76.3183 108.24C76.7449 108.973 76.9583 109.793 76.9583 110.7C76.9583 110.847 76.9516 111 76.9383 111.16C76.9383 111.32 76.9316 111.487 76.9183 111.66H69.3783C69.4316 112.433 69.6983 113.04 70.1783 113.48C70.6716 113.92 71.2649 114.14 71.9583 114.14C72.4783 114.14 72.9116 114.027 73.2583 113.8C73.6183 113.56 73.8849 113.253 74.0583 112.88H76.6583C76.4716 113.507 76.1583 114.08 75.7183 114.6C75.2916 115.107 74.7583 115.507 74.1183 115.8C73.4916 116.093 72.7783 116.24 71.9783 116.24ZM71.9983 107.92C71.3716 107.92 70.8183 108.1 70.3383 108.46C69.8583 108.807 69.5516 109.34 69.4183 110.06H74.3583C74.3183 109.407 74.0783 108.887 73.6383 108.5C73.1983 108.113 72.6516 107.92 71.9983 107.92ZM78.8914 116V106.08H81.1514L81.3714 107.42C81.6914 106.94 82.1114 106.56 82.6314 106.28C83.1647 105.987 83.7781 105.84 84.4714 105.84C86.0047 105.84 87.0914 106.433 87.7314 107.62C88.0914 107.073 88.5714 106.64 89.1714 106.32C89.7847 106 90.4514 105.84 91.1714 105.84C92.4647 105.84 93.4581 106.227 94.1514 107C94.8447 107.773 95.1914 108.907 95.1914 110.4V116H92.6314V110.64C92.6314 109.787 92.4647 109.133 92.1314 108.68C91.8114 108.227 91.3114 108 90.6314 108C89.9381 108 89.3781 108.253 88.9514 108.76C88.5381 109.267 88.3314 109.973 88.3314 110.88V116H85.7714V110.64C85.7714 109.787 85.6047 109.133 85.2714 108.68C84.9381 108.227 84.4247 108 83.7314 108C83.0514 108 82.4981 108.253 82.0714 108.76C81.6581 109.267 81.4514 109.973 81.4514 110.88V116H78.8914Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10322_10919)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 134,
    width: 38,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 134,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint38_linear_10322_10919)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 134,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint39_linear_10322_10919)"
  }))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3624 148.849C46.1258 148.611 46.1258 148.226 46.3624 147.988L48.7109 145.61H39.5053C39.1716 145.61 38.8985 145.335 38.8985 144.999C38.8985 144.663 39.1716 144.388 39.5053 144.388H48.7109L46.3564 142.017C46.1197 141.779 46.1197 141.394 46.3564 141.155C46.593 140.917 46.9753 140.917 47.212 141.155L50.6102 144.571C50.8469 144.81 50.8469 145.195 50.6102 145.433L47.2181 148.849C46.9814 149.081 46.593 149.081 46.3624 148.849Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10322_10919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6234 37.0198C47.6234 38.6472 48.1023 38.7013 48.9395 38.7013V38.8775H45.43V38.7013C46.0816 38.7013 46.3074 38.349 46.3074 37.0608V30.7833C46.3074 29.8475 46.1209 29.5092 45.4565 29.5092V29.333H47.8629C50.5087 29.333 52.2634 29.6583 52.2634 32.0714C52.2634 34.4846 50.5087 34.7968 47.8629 34.7968H47.6234V37.0208V37.0198ZM47.8629 34.6197C49.4851 34.6197 50.8139 34.5797 50.8139 32.0714C50.8139 29.5632 49.4184 29.5092 47.8629 29.5092H47.6234V34.6207H47.8629V34.6197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9485 38.8782H52.7149V38.7021C53.2203 38.5529 53.2468 38.3087 53.2468 37.6171V33.8618C53.2468 33.3874 53.1408 33.1972 52.5824 33.0481V32.885L54.4038 32.4917V37.6171C54.4038 38.3758 54.4705 38.58 54.9485 38.7021V38.8782ZM53.021 30.676C53.021 30.2826 53.3135 29.9844 53.6992 29.9844C54.0848 29.9844 54.3773 30.2826 54.3773 30.676C54.3773 31.0693 54.0711 31.3676 53.6992 31.3676C53.3272 31.3676 53.021 31.0553 53.021 30.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.303 38.8778H59.0694V38.7147C59.5748 38.5655 59.6013 38.3083 59.6013 37.6167V34.7012C59.6013 33.7793 59.1224 33.1688 58.245 33.1688C57.5541 33.1688 56.9957 33.8464 56.8888 34.3349V37.6297C56.8888 38.3754 56.9555 38.5786 57.4335 38.7007V38.8769H55.1998V38.7007C55.7052 38.5516 55.718 38.3213 55.718 37.6297V33.8474C55.718 33.373 55.6111 33.1968 55.0536 33.0477V32.8845L56.8878 32.4912V33.9145C57.1666 33.1278 58.0842 32.4912 58.9222 32.4912C59.9988 32.4912 60.7565 33.0197 60.7565 34.6601V37.6158C60.7565 38.3614 60.836 38.5916 61.3012 38.7137V38.8769L61.303 38.8778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4985 38.8778H65.2649V38.7147C65.7703 38.5655 65.7968 38.3083 65.7968 37.6167V34.7012C65.7968 33.7793 65.3179 33.1688 64.4405 33.1688C63.7496 33.1688 63.1912 33.8464 63.0842 34.3349V37.6297C63.0842 38.3754 63.151 38.5786 63.6289 38.7007V38.8769H61.3953V38.7007C61.9007 38.5516 61.9135 38.3213 61.9135 37.6297V33.8474C61.9135 33.373 61.8075 33.1968 61.2491 33.0477V32.8845L63.0833 32.4912V33.9145C63.3621 33.1278 64.2796 32.4912 65.1177 32.4912C66.1943 32.4912 66.952 33.0197 66.952 34.6601V37.6158C66.952 38.3614 67.0315 38.5916 67.4967 38.7137V38.8769L67.4985 38.8778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4545 38.0099L73.6135 38.078C73.534 38.4853 73.0816 38.9998 72.3907 38.9998C72.3907 38.9998 71.3406 39.0268 71.2611 37.8608C71.0747 38.5114 70.3042 38.9998 69.3729 38.9998C69.3729 38.9998 67.8577 38.9998 67.8577 37.6035C67.8577 36.2073 68.9873 35.9491 71.2611 35.3535V34.5668C71.2611 33.1706 70.5702 32.3839 69.5064 32.8854C68.9882 33.1436 68.9087 33.4008 68.9882 33.4139C69.1481 33.4409 69.2943 33.5089 69.4004 33.6581C69.5996 33.9293 69.5466 34.3366 69.2669 34.5398C69.001 34.757 68.6153 34.702 68.4161 34.4177C68.2698 34.2145 68.2433 33.9433 68.3493 33.7531C68.4426 33.5499 68.6683 33.1436 69.3866 32.7502C69.9578 32.452 70.6095 32.492 70.6095 32.492C72.058 32.492 72.4574 33.59 72.4574 35.2034V37.5085C72.4574 37.5085 72.4446 38.3622 73.056 38.3622C73.056 38.3622 73.3613 38.3622 73.4545 38.0099ZM69.0412 37.3183C69.0412 37.7117 69.2806 38.3893 70.0913 38.3893C70.7959 38.3893 71.1286 37.8738 71.2611 37.5485V35.5287C69.7193 35.9081 69.0412 36.5046 69.0412 37.3183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1848 37.2094C79.0386 37.887 78.3605 38.999 76.7254 38.999C75.2367 38.999 73.8274 37.7518 73.8274 35.7591C73.8274 34.0916 75.0237 32.4912 77.0581 32.4912C78.3614 32.4912 78.7598 33.1017 78.8796 33.318C78.9856 33.5081 79.0121 33.7654 78.8924 33.9825C78.7196 34.2668 78.3212 34.3898 78.0415 34.2128C77.7353 34.0366 77.6421 33.6433 77.8158 33.359C77.909 33.1968 78.0552 33.0877 78.1877 33.0747C78.3074 33.0477 77.9483 32.6683 77.0581 32.6683C76.5262 32.6683 75.0639 33.0747 75.0639 35.6099C75.0639 37.4135 76.061 38.1592 77.0051 38.2533C77.9757 38.3344 78.8 37.6978 79.0395 37.1413L79.1857 37.2094H79.1848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7639 38.8779H79.5303V38.7017C80.0357 38.5526 80.0622 38.3224 80.0622 37.6308V30.1872C80.0622 29.7128 79.9425 29.5227 79.3968 29.4145V29.2384L81.2311 28.8721V37.6308C81.2311 38.3764 81.2978 38.5796 81.763 38.7017V38.8779H81.7639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3873 37.2774C87.241 37.915 86.5099 38.999 84.9407 38.999C83.2792 38.999 82.0956 37.5887 82.0956 35.7991C82.0956 33.7924 83.345 32.4912 84.9937 32.4912C86.5355 32.4912 87.5993 33.4941 87.5993 35.623H83.345C83.398 37.4536 84.1958 38.1853 85.2459 38.2943C86.0438 38.3754 86.9879 37.8739 87.2264 37.2094L87.3854 37.2774H87.3873ZM86.4569 35.4468C86.4569 33.4671 85.5932 32.6674 84.9544 32.6674C84.1968 32.6674 83.3459 33.7383 83.3459 35.4468H86.4569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 32.5028H89.62V33.9624H88.9811V32.5028H87.6011V31.8512H88.9811V30.3916H89.62V31.8512H91V32.5028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3688 28.5273H34.0964V34.3416H34.3688C36.214 34.3416 37.7256 34.296 37.7256 31.4429C37.7256 28.5898 36.1381 28.5283 34.3688 28.5283V28.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3734 31.4421C39.3734 34.1712 37.3774 34.5413 34.3679 34.5413H34.0955V37.07C34.0955 38.2509 34.3176 38.703 34.7252 38.8754H43.9741L39.4804 30.9369L39.3003 30.6182C39.3478 30.8661 39.3734 31.1383 39.3734 31.4403V31.4421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5994 37.1171V29.9774C32.5994 29.0248 32.4285 28.6166 31.8509 28.542L30.4938 30.9393L26 38.8759H32.1105C32.4651 38.6783 32.5994 38.1759 32.5994 37.1161V37.1171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3688 28.3268H38.0035L34.9875 23L31.9725 28.3268H34.3688Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10322_10919",
    x: 0,
    y: 0,
    width: 189,
    height: 230,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_10919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_10919",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10322_10919",
    x: 18,
    y: 126,
    width: 54,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_10919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_10919",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10322_10919",
    x1: 122.659,
    y1: 156.096,
    x2: 122.659,
    y2: 213.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10322_10919",
    x1: 122.659,
    y1: 205.588,
    x2: 122.659,
    y2: 222.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10322_10919",
    x1: 122.659,
    y1: 157.253,
    x2: 122.659,
    y2: 204.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10322_10919",
    x1: 122.659,
    y1: 224.545,
    x2: 122.659,
    y2: 210.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10322_10919",
    x1: 155.673,
    y1: 211.781,
    x2: 155.673,
    y2: 207.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10322_10919",
    x1: 141.298,
    y1: 160.408,
    x2: 141.298,
    y2: 166.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10322_10919",
    x1: 130.134,
    y1: 165.24,
    x2: 130.134,
    y2: 172.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10322_10919",
    x1: 130.146,
    y1: 172.081,
    x2: 130.146,
    y2: 179.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10322_10919",
    x1: 130.134,
    y1: 179.127,
    x2: 130.134,
    y2: 186.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10322_10919",
    x1: 130.134,
    y1: 186.068,
    x2: 130.134,
    y2: 193.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#566AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4953AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10322_10919",
    x1: 106.441,
    y1: 160.618,
    x2: 106.441,
    y2: 166.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10322_10919",
    x1: 95.2766,
    y1: 165.24,
    x2: 95.2766,
    y2: 172.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10322_10919",
    x1: 95.2895,
    y1: 172.081,
    x2: 95.2895,
    y2: 179.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10322_10919",
    x1: 95.2766,
    y1: 179.127,
    x2: 95.2766,
    y2: 186.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10322_10919",
    x1: 138.21,
    y1: 215.614,
    x2: 138.247,
    y2: 228.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10322_10919",
    x1: 133.005,
    y1: 215.583,
    x2: 133.042,
    y2: 228.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10322_10919",
    x1: 133.696,
    y1: 200.81,
    x2: 133.696,
    y2: 219.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D8C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10322_10919",
    x1: 178.895,
    y1: 180.299,
    x2: 178.895,
    y2: 189.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10322_10919",
    x1: 177.819,
    y1: 179.142,
    x2: 177.819,
    y2: 191.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10322_10919",
    x1: 158.579,
    y1: 192.171,
    x2: 158.579,
    y2: 219.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10322_10919",
    x1: 149.475,
    y1: 207.672,
    x2: 143.92,
    y2: 199.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10322_10919",
    x1: 132.692,
    y1: 198.239,
    x2: 132.567,
    y2: 240.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10322_10919",
    x1: 182.04,
    y1: 198.213,
    x2: 182.04,
    y2: 240.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10322_10919",
    x1: 162.534,
    y1: 169.929,
    x2: 162.534,
    y2: 206.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10322_10919",
    x1: 169.465,
    y1: 200.527,
    x2: 169.465,
    y2: 193.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10322_10919",
    x1: 171.643,
    y1: 169.929,
    x2: 171.643,
    y2: 206.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10322_10919",
    x1: 169.519,
    y1: 198.213,
    x2: 169.519,
    y2: 240.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10322_10919",
    x1: 169.901,
    y1: 201.119,
    x2: 169.901,
    y2: 190.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10322_10919",
    x1: 154.562,
    y1: 198.213,
    x2: 154.562,
    y2: 240.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10322_10919",
    x1: 170.301,
    y1: 169.929,
    x2: 170.301,
    y2: 206.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10322_10919",
    x1: 169.91,
    y1: 170.645,
    x2: 169.91,
    y2: 181.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10322_10919",
    x1: 160.143,
    y1: 179.115,
    x2: 160.143,
    y2: 191.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10322_10919",
    x1: 159.041,
    y1: 180.3,
    x2: 159.041,
    y2: 189.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10322_10919",
    x1: 181.543,
    y1: 240.507,
    x2: 181.543,
    y2: 195.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10322_10919",
    x1: 183.56,
    y1: 240.507,
    x2: 183.56,
    y2: 195.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3C2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10322_10919",
    x1: 91.4125,
    y1: 218.848,
    x2: 91.4125,
    y2: 227.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10322_10919",
    x1: 89.8486,
    y1: 209.909,
    x2: 89.8486,
    y2: 215.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10322_10919",
    x1: 91.3948,
    y1: 215.606,
    x2: 91.3948,
    y2: 219.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10322_10919",
    x1: 64,
    y1: 156,
    x2: 24.0901,
    y2: 151.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10322_10919",
    x1: 45,
    y1: 102.604,
    x2: 45,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10322_10919"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10322_10919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 16,
    fill: "white",
    transform: "translate(26 23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasShort);
export default __webpack_public_path__ + "static/media/TAS_Short.ab8201dabe4b28ff4f6ec2c6fb7eb4e2.svg";
export { ForwardRef as ReactComponent };